export default class DtoBasin {
    constructor(obj) {
        this.id = obj.id // Option[Long],
        this.basinId = obj.basinId // Option[Long],
        this.basinCode = obj.basinCode // Option[String],
        this.basinName = obj.basinName // Option[String],
        this.connectionDate = obj.connectionDate // Option[DateTime]
    }
}